import { createContext, useContext } from 'react';

interface SessionContextInterface {
	postSession: ({ data }: { data: any }) => void;
}

const SessionContext = createContext<SessionContextInterface | undefined>(
	undefined
);

export const useSessionContext = () => {
	const context = useContext(SessionContext);
	if (context === undefined) {
		throw new Error(
			'SessionContext must be used within a SessionProvider'
		);
	}
	return context;
};

export default SessionContext;
